import '../../../../node_modules/shave/dist/jquery.shave.min';
import _debounce from 'lodash/debounce';
import Component from 'component';
import { getLineHeight } from '../helpers/getLineHeight';

class TrimText extends Component {
  constructor(el, config) {
    super(el, config);
    this.setupTrim();
  }

  setupDefaults() {
    this.originalText = this.$el.text().trim();
    this.dom = {
      $window: $(window)
    }
  }

  addListeners() {
    this.dom.$window.on('resize', _debounce(::this.setupTrim, 500));
  }

  setupTrim() {
    this.appliedConfig = this.config;

    if (this.config.responsive && this.config.responsive.length) {
      this.config.responsive.forEach(responsive => {
        if (window.matchMedia(`(max-width: ${responsive.breakpoint}px)`).matches) {
          this.appliedConfig = { ...this.config, ...responsive.config };
        }
      });
    }

    //Restore original text
    this.$el.html(this.originalText);
    let charTruncated = false,
      linesTruncated = false;

    if (this.appliedConfig.charCount) {
      if (this.originalText.length > this.appliedConfig.charCount) {
        this.$el.html(`${this.originalText.substring(0, this.appliedConfig.charCount + 1)}`);
        charTruncated = true;
      }
    }

    if (this.appliedConfig.lines) {
      const currentHeight = this.$el.height();
      const lineHeight = getLineHeight(this.$el);
      const maxHeight = (lineHeight * this.appliedConfig.lines) + lineHeight/2;

      if (currentHeight > maxHeight) {
        this.$el.shave(maxHeight);
        linesTruncated = true;
      }
    }

    if (charTruncated && !linesTruncated) {
      this.$el.html(`${this.$el.html().slice(0, -1)}…`);
    }
  }

}

export default TrimText;



// WEBPACK FOOTER //
// ./src/tc/js/components/TrimText.js